import _typeof from '@babel/runtime/helpers/typeof';

var DEFAULT_SORTABLE_DROPPABLE_ID = "Sortable";
var convertToDndKitDropAnimation = function convertToDndKitDropAnimation(dropAnimation) {
  if (dropAnimation === "default") {
    return void 0;
  }
  if (dropAnimation === "disabled") {
    return null;
  }
  return dropAnimation;
};
var isDraggableConnectedToDroppable = function isDraggableConnectedToDroppable(connectId, connectedTo) {
  if (!connectedTo) {
    return true;
  }
  if (!connectId) {
    return false;
  }
  var connectedToAsArray = typeof connectedTo === "string" ? [connectedTo] : connectedTo;
  return connectedToAsArray.includes(connectId);
};
var findDroppableIdAndIndex = function findDroppableIdAndIndex(id, items, getId) {
  var index = 0;
  if (id in items) {
    var _items$id;
    return {
      droppableId: id,
      index: ((_items$id = items[id]) === null || _items$id === void 0 ? void 0 : _items$id.length) || 0
    };
  }
  var result = Object.keys(items).find(function (key) {
    var _items$key;
    var itemIndex = (_items$key = items[key]) === null || _items$key === void 0 ? void 0 : _items$key.findIndex(function (item) {
      if (getId) {
        return getId(item) === id;
      } else if (_typeof(item) === "object" && "id" in item) {
        return item.id === id;
      } else {
        return item === id;
      }
    });
    if (itemIndex !== void 0 && itemIndex !== -1) {
      index = itemIndex;
      return true;
    }
  });
  return {
    droppableId: result,
    index: index
  };
};
var getDragStartEvent = function getDragStartEvent(active, items, getId) {
  var sourceContainerAndIndex = findDroppableIdAndIndex(active.id.toString(), items, getId);
  return {
    dragData: active.data.current.dragData || null,
    draggableId: active.id.toString(),
    sourceDroppableId: sourceContainerAndIndex.droppableId || null,
    sourceIndex: sourceContainerAndIndex.index || null
  };
};
var getDragCancelEvent = function getDragCancelEvent(active, over, items, getId) {
  var _over$data$current, _over$data$current2;
  var sourceDroppableIdAndIndex = findDroppableIdAndIndex(active.id.toString(), items, getId);
  var targetDroppableId = over === null || over === void 0 ? void 0 : (_over$data$current = over.data.current) === null || _over$data$current === void 0 ? void 0 : _over$data$current.sortable.containerId.toString();
  var targetIndex = over === null || over === void 0 ? void 0 : (_over$data$current2 = over.data.current) === null || _over$data$current2 === void 0 ? void 0 : _over$data$current2.sortable.index;
  if (!targetDroppableId || targetDroppableId === DEFAULT_SORTABLE_DROPPABLE_ID) {
    var targetDroppableIdAndIndex = over ? findDroppableIdAndIndex(over.id.toString(), items, getId) : void 0;
    if (targetDroppableIdAndIndex) {
      targetDroppableId = targetDroppableIdAndIndex.droppableId;
      targetIndex = targetDroppableIdAndIndex.index;
    }
  }
  return {
    dragData: active.data.current.dragData || null,
    draggableId: active.id.toString(),
    sourceDroppableId: sourceDroppableIdAndIndex.droppableId || null,
    sourceIndex: typeof sourceDroppableIdAndIndex.index === "number" ? sourceDroppableIdAndIndex.index : null,
    targetDroppableId: targetDroppableId || null,
    targetIndex: typeof targetIndex === "number" ? targetIndex : null
  };
};
var getDragOverEvent = function getDragOverEvent(active, over, items, getId) {
  var _active$data$current;
  var sourceDroppableIdAndIndex = findDroppableIdAndIndex(active.id.toString(), items, getId);
  var targetDroppableIdAndIndex = over ? findDroppableIdAndIndex(over.id.toString(), items, getId) : void 0;
  return {
    dragData: ((_active$data$current = active.data.current) === null || _active$data$current === void 0 ? void 0 : _active$data$current.dragData) || null,
    draggableId: active.id.toString(),
    sourceDroppableId: sourceDroppableIdAndIndex.droppableId || null,
    sourceIndex: sourceDroppableIdAndIndex.index || null,
    targetDroppableId: targetDroppableIdAndIndex ? targetDroppableIdAndIndex.droppableId : null,
    targetIndex: targetDroppableIdAndIndex !== null && targetDroppableIdAndIndex !== void 0 && targetDroppableIdAndIndex.index ? targetDroppableIdAndIndex.index : null
  };
};
var getDragEndEvent = function getDragEndEvent(active, over, items, getId) {
  var _over$data$current3, _over$data$current4;
  var sourceDroppableIdAndIndex = findDroppableIdAndIndex(active.id.toString(), items, getId);
  var targetDroppableId = over === null || over === void 0 ? void 0 : (_over$data$current3 = over.data.current) === null || _over$data$current3 === void 0 ? void 0 : _over$data$current3.sortable.containerId.toString();
  var targetIndex = over === null || over === void 0 ? void 0 : (_over$data$current4 = over.data.current) === null || _over$data$current4 === void 0 ? void 0 : _over$data$current4.sortable.index;
  if (!targetDroppableId || targetDroppableId === DEFAULT_SORTABLE_DROPPABLE_ID) {
    var targetDroppableIdAndIndex = over ? findDroppableIdAndIndex(over === null || over === void 0 ? void 0 : over.id.toString(), items, getId) : void 0;
    if (targetDroppableIdAndIndex) {
      targetDroppableId = targetDroppableIdAndIndex.droppableId;
      targetIndex = targetDroppableIdAndIndex.index;
    }
  }
  return {
    dragData: active.data.current.dragData || null,
    draggableId: active.id.toString(),
    sourceDroppableId: sourceDroppableIdAndIndex.droppableId || null,
    sourceIndex: typeof sourceDroppableIdAndIndex.index === "number" ? sourceDroppableIdAndIndex.index : null,
    targetDroppableId: targetDroppableId || null,
    targetIndex: typeof targetIndex === "number" ? targetIndex : null
  };
};

export { convertToDndKitDropAnimation, getDragCancelEvent, getDragEndEvent, getDragOverEvent, getDragStartEvent, isDraggableConnectedToDroppable };
